import { Component, OnChanges, SimpleChanges, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InitiativesDropdown } from '../initiatives-dropdown/initiatives-dropdown.component';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import { SalesCycle, CustomerStatus, SearchCustomer, CustomerInitiative } from '../../models/models';

@Component({
    selector: 'crm-prospects',
    templateUrl: './crm-prospects.component.html',
    standalone: false
})
export class CrmProspects implements OnInit, OnChanges {
    @ViewChild(InitiativesDropdown, { static: false }) initiativeDropdown: InitiativesDropdown | undefined;

    private repType: string = '';
    private employeeId: number = 0;
    private refreshProspects: boolean = false;

    public salesCycles: SalesCycle[] = [];
    public customerStatusList: CustomerStatus[] = [];
    public customerListBase: SearchCustomer[] = [];
    public customerList: SearchCustomer[] = [];
    public prospects: SearchCustomer[] = [];
    public rapportBuildings: SearchCustomer[] = [];
    public drawingPains: SearchCustomer[] = [];
    public qualifiedProspects: SearchCustomer[] = [];
    public prospectFreightSpend: number = 0;
    public rapportBuildingFreightSpend: number = 0;
    public drawingPainFreightSpend: number = 0;
    public qualifiedProspectFreightSpend: number = 0;

    public nameFilter: string = '';
    public codeFilter: string = '';
    public cityFilter: string = '';
    public stateFilter: string = '';
    public initiativeFilter: string = '';
    public salesRepFilter: string = '';
    public accountRepFilter: string = ''
    public beginActionDate: Date = new Date();
    public endActionDate: Date = new Date();
    public dateFilterChanged: boolean = false;
    public daysFilter: number = 0;

    constructor(private crmService: CRMService, private utilService: UtilService,
        private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        this.getcustomerStatusList();
        this.route.params.subscribe(params => {
            this.repType = params.repType;
            this.employeeId = params.employeeId;

            this.getCustomerList();
        });
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    private getcustomerStatusList() {
        this.crmService.getCustomerStatuses().subscribe(result => {
            //this.customerStatusList = result.filter(c => c.endOfCycleInd == false && c.description.indexOf('Lead') < 0);
            this.customerStatusList = result.filter(c => c.retiredInd != true && c.statusType == "Prospect" && c.abbreviation != "Disqualified");
            this.customerStatusList = this.customerStatusList.sort((left, right): number => {
                if (left.stage < right.stage) return -1;
                if (left.stage > right.stage) return 1;
                return 0;
            });
        });
    }

    private getCustomerList() {
        if (this.crmService.prospects.length > 0 && !this.refreshProspects) {
            this.customerListBase = this.crmService.prospects;
            this.filterCustomers();
        } else {
            this.utilService.isLoading = true;
            this.crmService.getSearchCustomerProspectsByEmployeeID(this.employeeId).subscribe(result => {
                this.utilService.isLoading = false;
                this.customerListBase = result.resultCollection;
                this.filterCustomers();
            });
        }        
    }

    public getCustomerCount(customerStatusID: number) {
        var lst = this.customerList.filter(t => t.customerStatusID == customerStatusID);
        return lst.length;
    }

    public getCustomerFreightSpend(customerStatusID: number) {
        var lst = this.customerList.filter(t => t.customerStatusID == customerStatusID);
        var freightSpend: number = 0;
        for (var i = 0; i < lst.length; i++) {
            if (!isNaN(lst[i].freightSpend)) {
                freightSpend += lst[i].freightSpend;
            }
        }
        return freightSpend;
    }

    public getCustomers(customerStatusID: number) {
        var lst = this.customerList.filter(t => t.customerStatusID == customerStatusID);
        return lst;
    }

    //private setFreightSpendTotals() {
    //    this.prospectFreightSpend = 0;
    //    this.rapportBuildingFreightSpend = 0;
    //    this.drawingPainFreightSpend = 0;
    //    this.qualifiedProspectFreightSpend = 0;

    //    this.prospects.forEach(customer => {
    //        this.prospectFreightSpend += customer.freightSpend;
    //    });
    //    this.rapportBuildings.forEach(customer => {
    //        this.rapportBuildingFreightSpend += customer.freightSpend;
    //    });
    //    this.drawingPains.forEach(customer => {
    //        this.drawingPainFreightSpend += customer.freightSpend;
    //    });
    //    this.qualifiedProspects.forEach(customer => {
    //        this.qualifiedProspectFreightSpend += customer.freightSpend;
    //    });
    //}

    public openCustomerStatusDialog(customerID: number, statusDescription: string) {
        var customer = this.customerList.find(t => t.customerID == customerID);
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/customer-detail/' + customer!.customerCode]));
        window.open('#' + url, '_blank');
        //var customerStatus = this.customerStatusList.find(s => s.description == statusDescription);

        //const dialogConfig = new MatDialogConfig();
        //dialogConfig.disableClose = false;
        //dialogConfig.autoFocus = true;
        //dialogConfig.data = {
        //    customerId: customerId,
        //    customerStatusId: customerStatus == null ? 3 : customerStatus.customerStatusId
        //}

        //const dialogRef = this.dialog.open(CustomerStatusChecklistDialog, dialogConfig);

        //dialogRef.afterClosed().subscribe(result => {
        //    this.refreshProspects = true;
        //    this.getCustomerList();
        //});
    }

    public filterCustomers() {
        //this.prospects = this.filterByStatus('Prospect');
        //this.rapportBuildings = this.filterByStatus('Rapport Building');
        //this.drawingPains = this.filterByStatus('Drawing Pain');
        //this.qualifiedProspects = this.filterByStatus('Qualified Prospect');
        //this.setFreightSpendTotals();
        this.customerList = this.customerListBase.filter(c =>
            (c.customerName.toLowerCase().includes(this.nameFilter.toLowerCase()) || this.nameFilter == '') &&
            (c.customerCode.toLowerCase().includes(this.codeFilter.toLowerCase()) || this.codeFilter == '') &&
            (c.cityName.toLowerCase().includes(this.cityFilter.toLowerCase()) || this.cityFilter == '') &&
            (c.stateAbbrev.toLowerCase().includes(this.stateFilter.toLowerCase()) || this.stateFilter == '') &&
            (c.initiatives.toLowerCase().includes(this.initiativeFilter.toLowerCase()) || this.initiativeFilter == '') &&
            (c.salesRepName.toLowerCase().includes(this.salesRepFilter.toLowerCase()) || this.salesRepFilter == '') &&
            (c.accountRepName.toLowerCase().includes(this.accountRepFilter.toLowerCase()) || this.accountRepFilter == '') &&
            (c.daysInStatus >= this.daysFilter) &&
            ((new Date(c.maxActionDate) >= this.beginActionDate && new Date(c.maxActionDate) < this.endActionDate) || this.dateFilterChanged == false));
    }

    //filterByStatus(status: string) {
    //    return this.customerList.filter(c => c.customerStatus == status &&
    //        (c.customerName.toLowerCase().includes(this.nameFilter.toLowerCase()) || this.nameFilter == '') &&
    //        (c.customerCode.toLowerCase().includes(this.codeFilter.toLowerCase()) || this.codeFilter == '') &&
    //        (c.cityName.toLowerCase().includes(this.cityFilter.toLowerCase()) || this.cityFilter == '') &&
    //        (c.stateAbbrev.toLowerCase().includes(this.stateFilter.toLowerCase()) || this.stateFilter == '') &&
    //        (c.initiatives.toLowerCase().includes(this.initiativeFilter.toLowerCase()) || this.initiativeFilter == '') &&
    //        (c.salesRepName.toLowerCase().includes(this.salesRepFilter.toLowerCase()) || this.salesRepFilter == '') &&
    //        (c.accountRepName.toLowerCase().includes(this.accountRepFilter.toLowerCase()) || this.accountRepFilter == '') &&
    //        (c.daysInStatus >= this.daysFilter) &&
    //        ((new Date(c.maxActionDate) >= this.beginActionDate && new Date(c.maxActionDate) < this.endActionDate) || this.dateFilterChanged == false));
    //}

    public clearFilters() {
        this.nameFilter = '';
        this.codeFilter = '';
        this.cityFilter = '';
        this.stateFilter = '';
        this.initiativeFilter = '';
        this.salesRepFilter = '';
        this.accountRepFilter = '';
        this.beginActionDate = new Date();
        this.endActionDate = new Date();
        this.dateFilterChanged = false;
        this.daysFilter = 0;
        this.initiativeDropdown!.selectedInitiative = { title: '', description: '' } as CustomerInitiative;
        this.filterCustomers();
    }

    public dateFilterChange(value: Date) {
        this.dateFilterChanged = true;
    }

    public getLastChecklist(customer: SearchCustomer) {
        var ok = customer;
    }
}
